import { Dispatch, SetStateAction } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useFormik } from 'formik';
import { Stack, Link } from '@mui/material';
import { TextField } from '@mui/material';
import { Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Values } from '.';
import { patchResetPassword } from '../../store/users/api';
import { useAppDispatch } from '../../store';
import { resetOtp } from '../../validation/resetPasswordSchema';

type Props = {
  setSteps: (val: number) => void;
  state: Values;
  setValues: Dispatch<SetStateAction<Values>>;
};

const Index: React.FC<Props> = ({ setSteps, state, setValues }) => {
  const dispatch = useAppDispatch();

  const {
    handleSubmit,
    getFieldProps,
    resetForm,
    isSubmitting,
    errors,
    touched,
  } = useFormik({
    initialValues: state,
    validationSchema: resetOtp,
    onSubmit: async (values) => {
      try {
        const response = await dispatch(
          patchResetPassword({ id: null, email: values.email, otp: values.otp })
        ).unwrap();
        setValues((prevValue) => ({
          ...prevValue,
          id: response?.key,
          otp: values.otp,
        }));
        resetForm();
        setSteps(3);
      } catch (error: any) {}
    },
  });

  return (
    <form
      autoComplete='off'
      noValidate
      onSubmit={handleSubmit}
    >
      <Stack spacing={3}>
        <TextField
          fullWidth
          autoComplete='email'
          type='email'
          label='Email address'
          disabled={true}
          {...getFieldProps('email')}
          error={Boolean(touched.email && errors.email)}
          helperText={touched.email && errors.email}
        />
        <TextField
          fullWidth
          type='text'
          label='OTP'
          {...getFieldProps('otp')}
          error={Boolean(touched.otp && errors.otp)}
          helperText={touched.otp && errors.otp}
        />
      </Stack>

      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{ my: 1 }}
      ></Stack>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='center'
      >
        <LoadingButton
          fullWidth
          size='large'
          type='submit'
          variant='contained'
          loading={isSubmitting}
        >
          Verify OTP
        </LoadingButton>
      </Stack>
      <Typography
        variant='body2'
        align='center'
        sx={{
          mt: 3,
        }}
      >
        Back to&nbsp;
        <Link
          variant='subtitle2'
          component={RouterLink}
          to={localStorage.getItem('resetPasswordFromCompanyLogin') === 'true' ? '/company-login' : '/login'}
          underline='hover'
        >
          Login
        </Link>
      </Typography>
    </form>
  );
};

export default Index;
